module.exports = __webpack_public_path__ + "img/visit-igd.c12a2554.svg";